import { render, staticRenderFns } from "./SelectColumnsSumColsConfig.vue?vue&type=template&id=ef3383be&scoped=true"
import script from "./SelectColumnsSumColsConfig.vue?vue&type=script&lang=ts"
export * from "./SelectColumnsSumColsConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3383be",
  null
  
)

export default component.exports